'use es6';

import I18n from 'I18n';
export default (currencyCode => {
  const currency = I18n.currencySymbols[currencyCode];
  return currency ? currency.symbol_native : null;
});